export { default } from './EcoContent';
